import TalentPersonalInfo from './TalentPersonalInfo';

export default TalentPersonalInfo;
